const BusinessPath = {
  TERMS_CONDITION: "https://pouchnation.com/terms/",
  PRIVACY: "https://pouchnation.com/privacy/",
  COMMUNITY_GUIDELINES: "https://pouchnation.com/",
};

export default BusinessPath;
